import JIRAConfig from 'consts/jira';
import Services from './index';
import { SEND_REPORT, TRACKING_URL } from 'consts/api';
import { htmlToMarkdown } from 'helpers/string';
import { browserDetect } from 'helpers';

const genTitle = (title) => `[REPORT] ${title}`;
const genCrash = (pathRoute) => `[CRASH REPORT] Path: ${pathRoute}`;

const genDescription = ({ description, account, env, category }) => `
  *Account report:* ${account}
  *Environment:* ${env}
  *Feature:* ${category}
  ${description}
`;

const genCrashLog = ({ account, email, env, description, pathRoute, hostname, fullPath }) => `
  *Account:* ${account}
  *Email:* ${email}
  *Environment:* ${env}
  *Path*: ${pathRoute}
  *Hostname*: ${hostname}
  *Fullpath*: ${fullPath}
  *Browser*: ${browserDetect()}
  *Agent*: ${window.navigator.userAgent}
  *Version*: ${window.sessionStorage.getItem('version')}

  ${description}
`;

class ReportServices {
  sendTaskJira({ title, content, account, env }) {
    return Services.post(SEND_REPORT, {
      fields: {
        project: {
          // key of project: E.g TA-331
          key: JIRAConfig.key,
        },
        summary: `[TICKET] ${title}`,
        description: genDescription({
          description: htmlToMarkdown(content),
          account,
          env,
          category: '',
        }),
        issuetype: {
          name: JIRAConfig.type.task,
        },
      },
    });
  }

  sendReport({ title, description, account, env, category }) {
    return Services.post(SEND_REPORT, {
      fields: {
        project: {
          // key of project: E.g TA-331
          key: JIRAConfig.key,
        },
        summary: genTitle(title),
        description: genDescription({ description, account, env, category }),
        issuetype: {
          name: JIRAConfig.type.bug,
        },
      },
    });
  }

  crashReport({
    account = '',
    email = '',
    env = '',
    description = '',
    pathRoute = '',
    hostname = '',
    fullPath = '',
  }) {
    return Services.post(SEND_REPORT, {
      fields: {
        project: {
          // key of project: E.g TA-331
          key: JIRAConfig.key,
        },
        summary: genCrash(pathRoute),
        description: genCrashLog({
          account,
          email,
          env,
          description,
          pathRoute,
          hostname,
          fullPath,
        }),
        issuetype: {
          name: JIRAConfig.type.bug,
        },
        assignee: {
          id: JIRAConfig.idUserAssign,
        },
      },
    });
  }

  tracking({ event = '', page = '' }) {
    return Services.post(TRACKING_URL, { event, page });
  }
}

export default new ReportServices();
